module.exports = __webpack_public_path__ + "static/media/help.95abba4a.svg";